<app-media-research-input
  (searchChange)="search($event)"
  [search]="query"
></app-media-research-input>
